import { render, staticRenderFns } from "./ProductCustomer.vue?vue&type=template&id=436427c1&scoped=true"
import script from "./ProductCustomer.vue?vue&type=script&lang=js"
export * from "./ProductCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436427c1",
  null
  
)

export default component.exports